<template>
    <!-- Additional Parts Modal -->
    <b-modal
            body-class="pb-0"
            id="additional-parts-modal"
            no-footer
            size="lg"
            title="Order additional parts">
        <b-tabs>
            <!-- Select Parts -->
            <b-tab
                    active
                    title="Select parts">
                <div class="row">
                    <div class="col-12">
                        <h3>Select parts</h3>
                    </div>
                    <div class="col-md-8">
                        <div class="form-group">
                            <label>Select an issue category</label>
                            <select class="custom-select form-control" v-model="partOrderCategory">
                                <option>Audio</option>
                                <option>Cameras</option>
                                <option>Connectivity</option>
                                <option>Body</option>
                                <option>Power</option>
                                <option>Sensors</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-12">
                        <label>Which parts do you need to order?</label>
                    </div>
                    <div class="col-12" v-if="partOrderCategory === 'Power'">
                        <div class="card-grid">
                            <article class="card-link-container">
                                <div class="card card-body card-body-sm horizontal bg-secondary-light">
                                    <div>
                                        <h5>Battery</h5>
                                        <ul class="list-unstyled mb-0">
                                            <li>1x Battery Tape</li>
                                            <li>1x Battery</li>
                                        </ul>
                                    </div>
                                    <div class="align-self-baseline p-2 text-success"><i class="fa fa-check"></i> Added</div>
                                </div>
                            </article>
                            <article class="card-link-container">
                                <div class="card card-body card-body-sm horizontal bg-secondary-light">
                                    <div>
                                        <h5>Charger Port</h5>
                                        <ul class="list-unstyled mb-0">
                                            <li>1x Sub PCB</li>
                                        </ul>
                                    </div>
                                    <button class="btn btn-success align-self-baseline">Order</button>
                                </div>
                            </article>
                            <article class="card-link-container">
                                <div class="card card-body card-body-sm horizontal bg-secondary-light">
                                    <div>
                                        <h5>Power</h5>
                                        <ul class="list-unstyled mb-0">
                                            <li>1x Battery</li>
                                            <li>1x Main PBA</li>
                                            <li>1x Battery Tape</li>
                                        </ul>
                                    </div>
                                    <button class="btn btn-success align-self-baseline">Order</button>
                                </div>
                            </article>
                            <article class="card-link-container">
                                <div class="card card-body card-body-sm horizontal bg-secondary-light">
                                    <div>
                                        <h5>Power Button</h5>
                                        <ul class="list-unstyled mb-0">
                                            <li>1x Power Button</li>
                                        </ul>
                                    </div>
                                    <button class="btn btn-success align-self-baseline">Order</button>
                                </div>
                            </article>
                        </div>
                    </div>
                    <div v-else class="col-12">
                        <empty-state
                                faIcon="battery-bolt"
                                small
                                title=""
                                subtitle="Please select Power from above">
                        </empty-state>
                    </div>
                </div>
            </b-tab>
            <!-- Added Parts -->
            <b-tab
                    title="Added parts (1)"><!-- TODO: Update this counter as parts are added/removed -->
                <div class="row">
                    <div class="col-12">
                        <h3>Added parts</h3>
                    </div>
                    <div class="scrollable-list scrollable-list-md">
                        <div class="card-grid">
                            <article class="card-link-container">
                                <div class="card card-body card-body-sm horizontal bg-secondary-light">
                                    <div>
                                        <h5>Battery</h5>
                                        <ul class="list-unstyled mb-0">
                                            <li>1x Battery Tape</li>
                                            <li>1x Battery</li>
                                        </ul>
                                    </div>
                                    <button class="btn btn-danger align-self-baseline">Delete</button>
                                </div>
                            </article>
                        </div>
                    </div>
                </div>
            </b-tab>
        </b-tabs>
        <template v-slot:modal-footer>
            <button type="button" class="btn btn-light" @click="$bvModal.hide('additional-parts-modal')">Cancel</button>
            <button type="button" class="btn btn-success">Submit order</button>
        </template>
    </b-modal>
</template>

<script>
    export default {
        data() {
            return {
                adding: false,
                partOrderCategory: null,
                partsAdded: []
            }
        }
    }
</script>

<style scoped>

</style>